<app-navbar></app-navbar>
<div class="container-flex">
    <div class="my-container">
        <div class="section-title-container">
            <div class="row">
                <h3 class="info-title">
                    Diputados
                    <button class="btn btn-success btn-sm ml-2" data-toggle="modal" data-target="#add-member">
                        Agregar
                    </button>
                    <button class="btn btn-success btn-sm ml-2" (click)="listarDiputados()">
                        Refrescar tabla
                    </button>
                </h3>
                <button type="button" class="btn btn-outline-dark outline-leer-mas">
                    <a class="nav-link" routerLink="/inicio">Inicio</a>
                </button>
            </div>
        </div>
        <div class="section-body-container">
            <div class="m-5 p-5" *ngIf="!members || !members?.length">

            </div>
            <table class="news-table table table-striped table-borderless table-responsive table-hover"
                *ngIf="members && members?.length">
                <caption class="sr-only">Grupos Parlamentarios y Diputados</caption>
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Apellido</th>
                        <th scope="col">País</th>
                        <th scope="col">Grupo Parlamentario</th>
                        <th scope="col">cargo</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of members | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize; let i = index;"
                        class="info-text">
                        <th scope="row">{{ i + 1 }}</th>
                        <td>{{ item.name | titlecase }}</td>
                        <td>{{ item.lastname }}</td>
                        <td>{{ item.country }}</td>
                        <td>{{ item.pg }}</td>
                        <td>{{ item.position}}</td>
                        <td class="text-center d-flex">
                            <div class="mr-1">
                                <button class="btn btn-primary btn-sm mt-1" data-toggle="modal" data-target="#view-news"
                                    (click)="setMember(item)">
                                    Ver
                                </button>
                            </div>
                            <div class="mr-1">
                                <button class="btn btn-warning btn-sm mt-1" data-toggle="modal"
                                    data-target="#update-news" (click)="setMember(item)">
                                    Editar
                                </button>
                            </div>
                            <div>
                                <button class="btn btn-danger btn-sm mt-1" data-toggle="modal"
                                    data-target="#delete-news" (click)="setMember(item)">
                                    Eliminar
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ngb-pagination class="d-flex justify-content-center" [collectionSize]="members?.length" [(page)]="page"
                [boundaryLinks]="true" [pageSize]="pageSize" size="sm" [maxSize]="5" [rotate]="true"
                *ngIf="members && members?.length">
            </ngb-pagination>
        </div>
    </div>
</div> 

<!-- Add News ∆ Modal ∆ -->
<div class="modal fade" id="add-member" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="add-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #addNews="ngForm" (submit)="addMember()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="add-news-title">Agregar Diputado</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearMember()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="add-title" class="group-title pb-1">
                            Nombre
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-title" #name="ngModel"
                            [(ngModel)]="member.name" name="name" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-author" class="group-title pb-1">
                            Apellidos
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-author" #lastname="ngModel"
                            [(ngModel)]="member.lastname" name="lastname" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-type" class="group-title pb-1">
                           Pais
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #country="ngModel" [(ngModel)]="member.country"
                            name="country" required aria-required="true" [disabled]="isSubmitting">
                            <option *ngFor="let type of countryTypes" [value]="type">{{type}}</option>
                        </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-author" class="group-title pb-1">
                            Grupo Parlamentario
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #pg="ngModel" [(ngModel)]="member.pg"
                        name="pg" required aria-required="true" [disabled]="isSubmitting">
                        <option *ngFor="let type of gpTypes" [value]="type">{{type}}</option>
                    </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-author" class="group-title pb-1">
                            Cargo
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #position="ngModel" [(ngModel)]="member.position"
                        name="position" required aria-required="true" [disabled]="isSubmitting">
                        <option *ngFor="let type of positionTypes" [value]="type">{{type}}</option>
                    </select>
                    </div>
                   
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="clearMember()"
                        [disabled]="isSubmitting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" type="submit" [disabled]="isSubmitting">
                        Agregar 
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- View News ∆ Modal ∆ -->
<div class="modal fade" id="view-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="view-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-center  p-4 bg-dark">
                <h5 class="modal-title group-title w-100 text-white" id="view-news-title">Ver Noticia</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearMember()">
                    <span aria-hidden="true" class="text-white">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group pb-4">
                    <label for="view-type" class="group-title pb-1">
                       Nombre
                    </label>
                    <input type="text" class="form-control" id="view-type" [value]="member.name" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-lang" class="group-title pb-1">
                        Apellido
                    </label>
                    <input type="text" class="form-control" id="view-lang" [value]="member.lastname" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-title" class="group-title pb-1">
                        País
                    </label>
                    <input type="text" class="form-control" id="view-title" [value]="member.country" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-author" class="group-title pb-1">
                        Grupo Parlamentario
                    </label>
                    <input type="text" class="form-control" id="view-author" [value]="member.pg" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-creationDate" class="group-title pb-1">
                        Cargo
                    </label>
                    <input type="text" class="form-control" id="view-creationDate" [value]="member.position"
                        readonly>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="clearMember()">
                    Salir
                </button>
            </div>
        </div>
    </div>
</div> 
<!-- Delete News ∆ Modal ∆ -->
<div class="modal fade" id="delete-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="delete-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #deleteNews="ngForm" (submit)="deleteEvent()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="delete-news-title">Eliminar Noticia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearMember()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="delete-title" class="group-title pb-1">
                            Título
                        </label>
                        <input type="text" class="form-control" id="delete-title" [value]="member.name + member.lastname" readonly>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <p class="info-text">
                                ¿Está seguro de que desea eliminar esta noticia?
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="clearMember()"
                        [disabled]="isDeleting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" type="submit" [disabled]="isDeleting">
                        Eliminar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- Update News ∆ Modal ∆ -->
<div class="modal fade" id="update-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="update-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #updateNews="ngForm" (submit)="actulizarDiputado()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="update-news-title">Actualizar  Diputado</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearMember()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="add-title" class="group-title pb-1">
                            Nombre
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-title" #name="ngModel"
                            [(ngModel)]="member.name" name="name" required aria-required="true"
                            [readonly]="isUpdating">
                    </div> 
                    <div class="form-group pb-4">
                        <label for="add-author" class="group-title pb-1">
                            Apellidos
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-author" #lastname="ngModel"
                            [(ngModel)]="member.lastname" name="lastname" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-type" class="group-title pb-1">
                           Pais
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #country="ngModel" [(ngModel)]="member.country"
                            name="country" required aria-required="true" [disabled]="isUpdating">
                            <option *ngFor="let type of countryTypes" [value]="type">{{type}}</option>
                        </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-author" class="group-title pb-1">
                            Grupo Parlamentario
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #pg="ngModel" [(ngModel)]="member.pg"
                        name="pg" required aria-required="true" [disabled]="isUpdating">
                        <option *ngFor="let type of gpTypes" [value]="type">{{type}}</option>
                    </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-author" class="group-title pb-1">
                            Cargo
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #position="ngModel" [(ngModel)]="member.position"
                        name="position" required aria-required="true" [disabled]="isUpdating">
                        <option *ngFor="let type of positionTypes" [value]="type">{{type}}</option>
                    </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="clearMember()"
                        [disabled]="isUpdating">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-warning" type="submit" [disabled]="isUpdating">
                        Actualizar Diputado
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>